import React  from 'react';
import './index.css';
import ReactDOM from 'react-dom';
//import 'bootstrap/dist/css/bootstrap.min.css'
//import '@fortawesome/fontawesome-free/css/all.min.css'
//import './scss/index.scss' 

import App from './App';
import * as serviceWorker from './serviceWorker';


//window.localStorage.clear();
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

